<template>
  <main>
    <router-view />
  </main>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { useRouter } from 'vue-router';
import { useMainStore } from './store';
import { storeToRefs } from 'pinia';
import { getUserInfo } from './api/userInfo';
export default defineComponent({
  mounted() {
    document.documentElement.style.setProperty('--el-color-primary', '#626aef');
    document.documentElement.style.setProperty('--el-color-primary-light-3', '#9197f4');
  }
})
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
